import { Reveal } from "@/components/Reveal";

const GRADES = [
  {
    n: "1",
    title: "Makelloser Zustand",
    short: "Wie neu. Perfekt restauriert oder Neuwagenzustand.",
    body: "Keine Mängel, Beschädigungen oder Gebrauchsspuren an Technik und Optik. Komplett und perfekt restauriertes Spitzenfahrzeug — wie neu (oder besser). Sehr selten.",
    note: "Ein Fahrzeug, auf das man begeistert zugeht und bei dem man auch bei genauer Prüfung keine Mängel feststellt. Basis: der Zustand bei Erstauslieferung des Herstellers.",
  },
  {
    n: "2",
    title: "Guter Zustand",
    short: "Mängelfrei mit leichten Gebrauchsspuren.",
    body: "Entweder seltener, guter unrestaurierter Originalzustand oder fachgerecht restauriert. Technisch und optisch einwandfrei mit leichten Gebrauchsspuren.",
    note: "Leichte Gebrauchsspuren spiegeln sich in geringer Gesamtlaufleistung bzw. Laufleistung nach der Restauration wider. Entsprechend niedrig ist auch der Verschleißgrad.",
  },
  {
    n: "3",
    title: "Gebrauchter Zustand",
    short: "Voll fahrbereit und verkehrssicher.",
    body: "Fahrzeuge ohne größere technische und optische Mängel, voll fahrbereit und verkehrssicher. Keine Durchrostungen. Keine sofortigen Arbeiten notwendig.",
    note: "Bei näherer Betrachtung Gebrauchsspuren und kleinere Mängel erkennbar — passend zur nachvollziehbaren Gesamtlaufleistung.",
  },
  {
    n: "4",
    title: "Verbrauchter Zustand",
    short: "Nur eingeschränkt fahrbereit.",
    body: "Sofortige Arbeiten zur Abnahme gem. § 29 StVZO nötig. Leichtere bis mittlere Durchrostungen. Fahrzeug in den Baugruppen komplett, aber nicht zwingend unbeschädigt.",
    note: "Diverse Mängel schon aus der Entfernung erkennbar. Nähere Inaugenscheinnahme zeigt deutliche Verschleißspuren.",
  },
  {
    n: "5",
    title: "Restaurierungs­bedürftiger Zustand",
    short: "Nicht fahrbereit. Umfangreiche Arbeiten nötig.",
    body: "Fahrzeug im mangelhaften Gesamtzustand. Umfangreiche Arbeiten in allen Baugruppen erforderlich. Nicht zwingend komplett.",
    note: "Selbst der Laie erkennt sofort deutliche Mängel oder Fehlteile. Kann auch als Teileträger dienen.",
  },
];

export default function Zustandsnoten() {
  return (
    <section className="py-24 lg:py-32 px-6 lg:px-10 bg-[color:var(--ink)] text-[color:var(--cream)]">
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-14">
            <div className="lg:col-span-7">
              <div className="text-[10px] tracking-[0.24em] uppercase text-[color:var(--cream)]/60 mb-6">— Zustandseinstufung &amp; Wertermittlung</div>
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[0.98]">
                Classic Data <em className="italic">Zustandsnoten.</em>
              </h2>
            </div>
            <p className="lg:col-span-5 text-[color:var(--cream)]/75 leading-relaxed text-[15px]">
              Am Ende einer jeden Bewertung steht die Gesamtzustandsnote des Fahrzeuges — das gemittelte Ergebnis aus den Zuständen der Einzelbaugruppen. Das Classic-Data-System orientiert sich an den deutschen Schulnoten: von 1 „sehr gut" bis 5 „mangelhaft", Zwischenstufen wie 2− oder 3+ sind möglich.
            </p>
          </div>
        </Reveal>

        <div className="border-t border-white/20">
          {GRADES.map((g, i) => (
            <Reveal key={g.n} delay={i * 0.08}>
              <article className="grid grid-cols-12 gap-6 py-10 border-b border-white/20 items-start hover:bg-white/[0.03] transition-colors duration-500">
                <div className="col-span-12 md:col-span-2 flex md:block items-baseline gap-4">
                  <div className="text-[10px] tracking-[0.24em] uppercase text-[color:var(--cream)]/50">Zustand</div>
                  <div className="font-serif text-6xl md:text-7xl leading-none text-[color:var(--burgundy-light)] md:mt-3">{g.n}</div>
                </div>
                <div className="col-span-12 md:col-span-4">
                  <h3 className="font-serif text-2xl md:text-3xl leading-[1.15]">{g.title}</h3>
                  <div className="mt-3 text-[color:var(--cream)]/70 text-sm italic">{g.short}</div>
                </div>
                <div className="col-span-12 md:col-span-6 space-y-3">
                  <p className="text-[15px] leading-relaxed text-[color:var(--cream)]/90">{g.body}</p>
                  <p className="text-[13px] leading-relaxed text-[color:var(--cream)]/55 italic border-l-2 border-[color:var(--burgundy-light)] pl-4">{g.note}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6 text-[13px] text-[color:var(--cream)]/60 leading-relaxed">
          <p>
            Durch heutige technische Möglichkeiten (Schweißarbeiten, computergestützte Messtechnik), veränderte Materialien (Lack, Oberflächen­veredelung) und umfangreichen Korrosionsschutz kann ein komplett restauriertes Fahrzeug den Zustand der Erstauslieferung sogar übertreffen.
          </p>
          <p>
            Zustand, Originalität und Historie werden vom besichtigenden Kfz-Sachverständigen unabhängig voneinander bewertet und fließen in die Wertfindung mit ein.<br /><br />
            <span className="text-[color:var(--cream)]/40">Definition der Zustandsnoten © Classic Data Marktbeobachtung GmbH &amp; Co KG</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
